module.exports = __webpack_public_path__ + "img/logo1.cd29fe8b.jpg";